import '@orobix/label-studio/build/static/css/main.css'

import { faFlag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Loading } from '@orobix/orobix-fe-components'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ConditionalWrapper } from '../ConditionalWrapper/ConditionalWrapper'
import useStyles from './Annotator.styles'

/**
 * Manage annotator view offering two different layouts:
 * - with lightbox, i.e., open the annotator in a modal and goes fullscreen
 * - without lightbox, i.e., open the annotator inline
 */
export const AnnotatorContainer = ({
  children,
  isLoading = false,
  withLightbox = false,
  topbar,
  readonlyMessage,
}: {
  children: React.ReactElement
  withLightbox?: boolean
  isLoading?: boolean
  topbar?: React.ReactNode
  readonlyMessage?: string
}) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const orLoading = (c: React.ReactElement) =>
    isLoading ? (
      <div className={classes.loadingContainer}>
        {t('Loading')} <Loading />
      </div>
    ) : (
      c
    )

  return (
    <ConditionalWrapper
      condition={withLightbox}
      renderIfTrue={(items) => (
        <div className={classes.lightboxWrapper}>
          {topbar}
          {readonlyMessage && (
            <div className={classes.readonlyBanner}>
              <FontAwesomeIcon icon={faFlag} />
              {readonlyMessage}
            </div>
          )}
          <div className={classes.lightboxContainer}>{orLoading(items)}</div>
        </div>
      )}
      renderIfFalse={(items) => (
        <div className={classes.wrapper}>{orLoading(items)}</div>
      )}
    >
      {children}
    </ConditionalWrapper>
  )
}

export default AnnotatorContainer
